import PropTypes from "prop-types";
import validator from "validator";

const ReadApplicationLetter = ({ name, letterText }) => {
  return (
    <div className="container--inner_modal">
      <div container="container--inner_modal_top">
        <h2 className="header header--modal_heading-dark">{name}</h2>

        <label
          className="header header--text_label header--section_data_label"
          htmlFor="applicationletter"
        >
          Application Letter
          <textarea
            className="input input--form_input input--form_text_area apply--text_area"
            type="text"
            name="applicationletter"
            row="10"
            cols="1"
            disabled
            value={validator.unescape(letterText)}
            aria-label="Application Letter"
          />
        </label>
      </div>
    </div>
  );
};

export default ReadApplicationLetter;

ReadApplicationLetter.propTypes = {
  name: PropTypes.string,
  letterText: PropTypes.string,
};
